import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const login = (login, password) =>
  api.post('/auth/login', { login, password }).then(r => r.data);

export const getMe = () =>
  api.get('/auth/me').then(r => r.data);

// Accepte soit une date unique, soit une plage
export const getPlanning = (dateOuDebut, dateFin) => {
  const params = dateFin
    ? { dateDebut: dateOuDebut, dateFin }
    : { date: dateOuDebut, dateDebut: dateOuDebut, dateFin: dateOuDebut };
  return api.get('/planning', { params }).then(r => r.data);
};

// Recherche dans les interventions du technicien connecté, toutes dates
// confondues : nom du client, référence O ou W, adresse, ville, code postal.
export const rechercherPlanning = (q, config = {}) =>
  api.get('/planning/recherche', { params: { q }, ...config }).then(r => r.data);

// Bilan d'une période : interventions réalisées, avec type et statut de clôture.
export const getBilan = (debut, fin) =>
  api.get('/planning/bilan', { params: { debut, fin } }).then(r => r.data);

// Le téléchargement se fait par fetch, pour porter l'en-tête d'authentification.
export const urlExportBilan = (debut, fin) =>
  `/api/planning/bilan/export?debut=${encodeURIComponent(debut)}&fin=${encodeURIComponent(fin)}`;

export const getDossier = (id) =>
  api.get(`/dossier/${id}`).then(r => r.data);

export const getCR = (dossierId, refWorkOrder = null) => {
  const url = refWorkOrder
    ? `/cr/${dossierId}?ref_work_order=${encodeURIComponent(refWorkOrder)}`
    : `/cr/${dossierId}`;
  return api.get(url).then(r => r.data);
};

export const saveCR = (payload) =>
  api.post('/cr', payload).then(r => r.data);

export const getSAVSecteur = () =>
  api.get('/planning/sav-secteur').then(r => r.data);

export default api;
